import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Area, AreaChart,
} from "recharts";
import { formatDate } from "@/lib/weatherUtils";

const TICK_STYLE = { fill: "#64748B", fontSize: 11 };

function fmtTick(iso, range) {
  const d = new Date(iso);
  const opts = { timeZone: "Europe/Rome" };
  if (range === "24h") return d.toLocaleTimeString("it-IT", { ...opts, hour: "2-digit", minute: "2-digit" });
  if (range === "12m") return d.toLocaleDateString("it-IT", { ...opts, month: "short" });
  return d.toLocaleDateString("it-IT", { ...opts, day: "2-digit", month: "2-digit" });
}

export default function WeatherChart({ points = [], dataKey, unit = "", color = "#0EA5E9", range = "24h", area = false, testId }) {
  const data = points.map((p) => ({ ts: p.ts, value: p[dataKey] }));

  const Chart = area ? AreaChart : LineChart;

  return (
    <div className="h-64 md:h-72 w-full" data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <Chart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={`grad-${dataKey}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.35} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#EEF2F7" strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="ts" tick={TICK_STYLE} tickFormatter={(v) => fmtTick(v, range)} axisLine={false} tickLine={false} minTickGap={40} />
          <YAxis tick={TICK_STYLE} axisLine={false} tickLine={false} width={40} />
          <Tooltip
            contentStyle={{
              background: "rgba(11,19,43,0.94)",
              border: "none",
              borderRadius: 12,
              color: "#fff",
              fontFamily: "Outfit, sans-serif",
              fontSize: 12,
              padding: "10px 14px",
            }}
            labelStyle={{ color: "#FBBF24", fontSize: 11, marginBottom: 4 }}
            labelFormatter={(v) => formatDate(v)}
            formatter={(v) => [`${v}${unit ? ` ${unit}` : ""}`, ""]}
          />
          {area ? (
            <Area type="monotone" dataKey="value" stroke={color} strokeWidth={2.4} fill={`url(#grad-${dataKey})`} />
          ) : (
            <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2.4} dot={false} activeDot={{ r: 4 }} />
          )}
        </Chart>
      </ResponsiveContainer>
    </div>
  );
}
